import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../api/api";

// Async thunks

export const addVideo = createAsyncThunk(
  "video/add_video",
  async (video, { rejectWithValue }) => {
    try {
      const { data } = await api.post("/add-video", video, { withCredentials: true });
      return data;
    } catch (error) {
      return rejectWithValue(error.response?.data || { error: "Server error" });
    }
  }
);

export const getVideos = createAsyncThunk(
  "video/get_videos",
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await api.get("/get-video", { withCredentials: true });
      return data;
    } catch (error) {
      return rejectWithValue(error.response?.data || { error: "Server error" });
    }
  }
);

export const getsingleVideo = createAsyncThunk(
  "video/get_single_video",
  async (videoId, { rejectWithValue }) => {
    try {
      const { data } = await api.get(`/get-videos/${videoId}`, { withCredentials: true });
      return data;
    } catch (error) {
      return rejectWithValue(error.response?.data || { error: "Server error" });
    }
  }
);

export const updateVideo = createAsyncThunk(
  "video/update_video",
  async (video, { rejectWithValue }) => {
    try {
      const { data } = await api.post("/update-video", video, { withCredentials: true });
      return data;
    } catch (error) {
      return rejectWithValue(error.response?.data || { error: "Server error" });
    }
  }
);

export const deleteVideo = createAsyncThunk(
  "video/delete_video",
  async (id, { rejectWithValue }) => {
    try {
      const { data } = await api.delete(`/delete-video/${id}`, { withCredentials: true });
      return { id, message: data.message };
    } catch (error) {
      return rejectWithValue(error.response?.data || { error: "Server error" });
    }
  }
);

// Slice

const videoSlice = createSlice({
  name: "video",
  initialState: {
    videos: [],
    videoss: null,
    successMessage: "",
    errorMessage: "",
    loader: false,
  },
  reducers: {
    clearMessages: (state) => {
      state.successMessage = "";
      state.errorMessage = "";
    },
  },
  extraReducers: (builder) => {
    builder
      // Add video
      .addCase(addVideo.pending, (state) => {
        state.loader = true;
      })
      .addCase(addVideo.fulfilled, (state, { payload }) => {
        state.loader = false;
        state.successMessage = payload.message;
        // Optionally push the new video to videos list if needed
        // state.videos.push(payload.video);
      })
      .addCase(addVideo.rejected, (state, { payload }) => {
        state.loader = false;
        state.errorMessage = payload.error;
      })

      // Get all videos
      .addCase(getVideos.pending, (state) => {
        state.loader = true;
      })
      .addCase(getVideos.fulfilled, (state, { payload }) => {
        state.loader = false;
        state.videos = payload.videoData;
      })
      .addCase(getVideos.rejected, (state, { payload }) => {
        state.loader = false;
        state.errorMessage = payload.error;
      })

      // Get single video
      .addCase(getsingleVideo.pending, (state) => {
        state.loader = true;
      })
      .addCase(getsingleVideo.fulfilled, (state, { payload }) => {
        state.loader = false;
        state.videoss = payload.videoDatas || null;
      })
      .addCase(getsingleVideo.rejected, (state, { payload }) => {
        state.loader = false;
        state.errorMessage = payload.error;
      })

      // Update video
      .addCase(updateVideo.pending, (state) => {
        state.loader = true;
      })
      .addCase(updateVideo.fulfilled, (state, { payload }) => {
        state.loader = false;
        state.successMessage = payload.message;
        // Update video in the list if needed, or replace videos array
        // For now, assuming payload contains full updated list or updated video
        // You may want to update `videos` accordingly here
      })
      .addCase(updateVideo.rejected, (state, { payload }) => {
        state.loader = false;
        state.errorMessage = payload.error;
      })

      // Delete video
      .addCase(deleteVideo.pending, (state) => {
        state.loader = true;
      })
      .addCase(deleteVideo.fulfilled, (state, { payload }) => {
        state.loader = false;
        state.successMessage = payload.message;
        state.videos = state.videos.filter((video) => video._id !== payload.id);
      })
      .addCase(deleteVideo.rejected, (state, { payload }) => {
        state.loader = false;
        state.errorMessage = payload.error;
      });
  },
});

export const { clearMessages } = videoSlice.actions;
export default videoSlice.reducer;
